import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import {
  activeExclusionsEndpoint,
  getCategoriesEndpoint,
  selfExclusionsCodes,
} from './selfExclusion.config';
import {
  GetSelfExclusionsResponse,
  ResponseMessageWithExclusion,
  SELF_EXCLUSION_COVERAGE,
  SELF_EXCLUSION_TYPE,
  SelfExclusionApiItem,
  SelfExclusionCategory,
} from './selfExclusion.type';
import {
  closeResponseFeedback,
  openResponseFeedback,
  selectExclusion,
  setSelectedEditType,
} from './selfExclusions.actions';

const serverData: SelfExclusionApiItem[] = [
  {
    code: 'CROSS-PERM',
    accountStatus: 'LIMITED',
    type: SELF_EXCLUSION_COVERAGE.CROSS,
    period: 0,
    periodUnit: 'D',
    startTimestamp: 1269002844000,
    endTimestamp: 1469002844000,
    categoryCode: 'BINGO',
    productCode: 'SS',
    productDescription: 'Online Bingo',
  },
  // {
  //   code: 'CROSS-PERM',
  //   accountStatus: 'LIMITED',
  //   type: SELF_EXCLUSION_COVERAGE.LOCAL,
  //   period: 0,
  //   periodUnit: 'D',
  //   startTimestamp: 1865359736851, // 16 Dec 2024
  //   endTimestamp: null, // 31 Dec 2024
  //   categoryCode: 'FOOTBALL_POOL',
  //   productCode: 'SS',
  //   productDescription: 'Totocalcio',
  // },
  //  {
  //   code: 'CROSS-TEMP',
  //   accountStatus: 'LIMITED',
  //   type: SELF_EXCLUSION_COVERAGE.LOCAL,
  //   period: 887878,
  //   periodUnit: 'D',
  //   startTimestamp: 1869002844000, // 16 Dec 2024
  //   endTimestamp: 1869002844000, // 31 Dec 2024
  //   categoryCode: 'HORSE_SHOP',
  //   productCode: 'SS',
  //   productDescription: 'Ippica Nazionale',
  // },
  {
    code: 'LOCAL-TEMP',
    accountStatus: 'LIMITED',
    type: SELF_EXCLUSION_COVERAGE.LOCAL,
    period: 8989,
    periodUnit: 'D',
    startTimestamp: 1865359736851, // 16 Dec 2024
    endTimestamp: 1865359736851, // 31 Dec 2024
    categoryCode: 'HORSE_AGENCY',
    productCode: 'SS',
    productDescription: 'Scommesse Ippiche e Ippica a quota fissa',
  },
  {
    code: 'LOCAL-PERM',
    accountStatus: 'LIMITED',
    type: SELF_EXCLUSION_COVERAGE.LOCAL,
    period: 0,
    periodUnit: 'D',
    startTimestamp: 1265359736851, // 16 Dec 2024
    categoryCode: 'SKILL_BASED',
    productCode: 'SS',
    productDescription: 'Casinò, Poker, Quick Games e Giochi di Carte',
  },
  {
    code: 'LOCAL-PERM',
    accountStatus: 'LIMITED',
    type: SELF_EXCLUSION_COVERAGE.LOCAL,
    period: 0,
    periodUnit: 'D',
    startTimestamp: 1865359736851, // 16 Dec 2024
    endTimestamp: 1865359736851, // 31 Dec 2024
    categoryCode: 'SPORTS_BETTING',
    productCode: 'SS',
    productDescription: 'Scommesse',
  },
  {
    code: 'LOCAL-PERM',
    accountStatus: 'LIMITED',
    type: SELF_EXCLUSION_COVERAGE.LOCAL,
    period: 0,
    periodUnit: 'D',
    startTimestamp: 1265359736851, // 16 Dec 2024
    endTimestamp: null, // 31 Dec 2024
    categoryCode: 'VIRTUAL_RACE',
    productCode: 'SS',
    productDescription: 'Virtual Race',
  },
  // {
  //   code: 'CROSS-TEMP',
  //   accountStatus: 'LIMITED',
  //   type: SELF_EXCLUSION_COVERAGE.CROSS,
  //   period: 15,
  //   periodUnit: 'D',
  //   startTimestamp: 1734307200000,
  //   endTimestamp: 1735603200000,
  //   categoryCode: 'ALL',
  //   productCode: 'QG',
  //   productDescription: 'Quick Games',
  // },
  // {
  //   code: 'CROSS-PERM',
  //   accountStatus: 'LIMITED',
  //   type: SELF_EXCLUSION_COVERAGE.CROSS,
  //   period: 0,
  //   periodUnit: 'D',
  //   startTimestamp: 1934307200000, // 16 Dec 2024
  //   endTimestamp: null, // 31 Dec 2024
  //   categoryCode: 'BINGO',
  //   productCode: 'SS',
  //   productDescription: 'Scommesse Sportive',
  // },
];
// const serverData: SelfExclusionApiItem[] = []
const initialState = {
  categories: [] as SelfExclusionCategory[],
  activeExclusions: {} as Record<string, SelfExclusionApiItem[]>,
  selectedExclusion: '' as SELF_EXCLUSION_COVERAGE | '',
  selectedMode: 'add' as 'add' | 'edit' | '',
  selectedEditType: '' as SELF_EXCLUSION_TYPE | '',
  responseFeedback: null as null | ResponseMessageWithExclusion,
};
// for (const item of serverData) {
//   if (!selfExclusionsCodes.has(item.code)) continue;

//   const coverage = item.code.split('-')[0] as SELF_EXCLUSION_COVERAGE;
//   const existing = initialState.activeExclusions[coverage] ?? [];

//   initialState.activeExclusions[coverage] = [...existing, item];
// }

const selfExclusionReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(apiRequestSuccess, (state, action) => {
      const { payload } = action;

      if (payload.resourceId === activeExclusionsEndpoint) {
        console.log('payload.response.data', payload.response.data);
        const responseObject =
          (payload.response.data
            .responseObject as GetSelfExclusionsResponse['responseObject']) ||
          null;

        // responseObject.selfExclusionList = serverData; // For testing purpose

        if (responseObject && Array.isArray(responseObject.selfExclusionList)) {
          const selfExclusionList = responseObject.selfExclusionList;
          const activeExclusionsMap: Record<string, SelfExclusionApiItem[]> =
            {};

          for (const item of selfExclusionList) {
            if (!selfExclusionsCodes.has(item.code)) continue;

            const coverage = item.code.split('-')[0] as SELF_EXCLUSION_COVERAGE;

            const existing = activeExclusionsMap[coverage] ?? [];

            activeExclusionsMap[coverage] = [...existing, item];
          }

          return {
            ...state,
            activeExclusions: activeExclusionsMap,
          };
        }
      }

      if (payload.resourceId === getCategoriesEndpoint) {
        const responseObject =
          (payload.response.data
            .responseObject as GetSelfExclusionsResponse['responseObject']) ||
          null;

        if (responseObject && Array.isArray(responseObject)) {
          const categories = responseObject
            .map((category) => {
              if (typeof category === 'string') {
                return { categoryCode: category };
              }

              if (!category || typeof category !== 'object') return null;

              const categoryCode = (category as SelfExclusionCategory)
                .categoryCode;
              const description =
                (category as { description?: string }).description ??
                (category as { categoryDescription?: string })
                  .categoryDescription;

              if (!categoryCode) return null;

              return {
                categoryCode,
                description,
              };
            })
            .filter(Boolean) as SelfExclusionCategory[];

          return {
            ...state,
            categories,
          };
        }
      }
    })

    .addCase(selectExclusion, (state, { payload: { exclusionCode, mode } }) => {
      return {
        ...state,
        selectedExclusion: exclusionCode,
        selectedMode: mode ?? 'add',
        selectedEditType: '',
      };
    })
    .addCase(setSelectedEditType, (state, { payload }) => {
      return {
        ...state,
        selectedEditType: payload,
      };
    })
    .addCase(openResponseFeedback, (state, { payload }) => {
      console.log('payload >>', payload);

      return {
        ...state,
        responseFeedback: {
          show: true,
          type: payload?.type,
          coverage: payload?.coverage,
        },
      };
    })
    .addCase(closeResponseFeedback, (state, { payload }) => {
      return {
        ...state,
        responseFeedback: null,
      };
    }),
);

export default selfExclusionReducer;
